import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class CreditLimitFormModel extends BaseModel {
  credit_limit = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    credit_limit: 'required'
  };

  attributeHints = {
    credit_limit: i18n.t('Please Enter the Bidding Limit')
  };

  attributeLabels = {
    credit_limit: i18n.t('Bidding Limit'),
  };
}
